import styled from 'styled-components';

export const StyledIconWrapper = styled.div`
  width: 60px;
  margin: 0 auto;
`;
